module.exports = {
	"articleTitle1": "Tio's tacos satisfy a Mexican food skeptic - ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Tio's Mexican Cafe",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/best-ann-arbor-and-winners-are",
	"articleSnippet1": "Oct 11, 2012 ... But from the moment I stepped onto campus, people couldn't stop bragging about \nTio's Mexican Cafe (over on East Liberty). So after all the ...",
	"articleSnippet2": "Apr 9, 2003 ... Korean Food: University Cafe. Late Night Munchies: Pizza House. Lunch: Amer's. \nMexican: Tio's. Microbrew: Leopold Brothers of Ann Arbor.",
	"foodRecommendations": [
		{
			"text": "The nacho grande is very good. I'd recommend getting it with chicken.",
			"person": "Erik Forkin"
		},
		{
			"text": "The chips are not free with the meal, which is kinda lame.",
			"person": "Ben Iaderosa"
		}
	],
	"articleTitle2": "Best of Ann Arbor: And the winners are",
	"address": "401 E Liberty St #2, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279682,
		"lng": -83.743396
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/tios.json
// module id = 987
// module chunks = 0